<template>
  <div v-loading="showFlag">
    <t-card>
      <div>
        <!-- 製品クローズ選択テーブル -->
        <t-table
          ref="productCloseSelectTable"
          :data="productCloseSelectTable"
          header-cell-class-name="bg-default"
          :height="detailHeight"
          :cell-class-name="tableCellClassName"
          @selection-change="changeSelect"
          border
        >
          <t-table-column type="selection" min-width="55" align="center" />
          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :align="column.align"
          >
            <template slot-scope="scope">
              <t-input
                class="cell_input"
                v-if="editCellData(scope.row, scope.column)"
                :maxLength="column.maxLength"
                v-model="scope.row[column.prop]"
                :ref="`input${scope.row.index}-${scope.column.property}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, scope.column.property)
                "
              />
              <span v-else>
                {{ scope.row[column.prop] }}
              </span></template
            >
          </t-table-column></t-table
        >
        <t-row>
          <t-col :span="24" class="right">
            <!-- 確定ボタン -->
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              @click="confirmClick()"
              :disabled="productCloseSelectTable.length == 0"
            >
              <i class="el-icon-check"></i>{{ $t("resource.sys.sure") }}
            </t-button>
          </t-col>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  searchProductNormalInfoByAobQuoteNo,
  updateProductCloseSelectData,
} from "@/services/acceptOrder";
import { cmpDetailData, getDialogContentHeight } from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, STR_EMPTY } from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,
      //製品クローズ選択テーブル
      productCloseSelectTable: [],

      //製品クローズ選択テーブルの列
      columns: [
        {
          prop: "aodProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          align: "left",
        },
        {
          prop: "aodProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "left",
        },
        {
          prop: "aodProdQuantity",
          label: t("resource.ACCEPT_ORDER.ACCEPT_COUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "right",
        },
        {
          prop: "aodRemarks",
          label: t("resource.COMMON_CONSTANT.BIKOU"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          align: "left",
          maxLength: 200,
        },
      ],

      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      ),

      data: null,

      showFlag: false,

      closeStateList: [
        {
          value: "0",
          label: "-",
        },
        {
          value: "1",
          label: "クローズ",
        },
      ],
      //クローズ状態のデータ
      closeDataList: [],
    };
  },
  props: {
    //見積No.
    aobQuoteNo: {
      Type: String,
      default: STR_EMPTY,
    },
  },
  mounted() {
    this.Init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // 初期化
    Init() {
      this.showFlag = true;
      //検索製品クローズ選択情報
      searchProductNormalInfoByAobQuoteNo({
        aobQuoteNo: this.aobQuoteNo,
      })
        .then((res) => {
          //製品クローズ選択テーブル
          this.productCloseSelectTable = res;

          //クローズ状態のデータ
          let filteredItems = this.productCloseSelectTable.filter(
            (item) => item.aodCloseState === "1"
          );
          this.closeDataList = filteredItems.map((item) => item.aodProdNo);

          //データ処理
          this.dataProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      );
    },

    //データ処理
    dataProcess() {
      this.productCloseSelectTable.map((item) => {
        //クローズ状態
        if (item.aodCloseState == "1") {
          //クローズ状態をチェックする
          this.$nextTick(() => {
            this.$refs.productCloseSelectTable.toggleRowSelection(item, true);
          });
        }
      });

      //読み込み回数=1
      if (this.numLoads == 1) {
        //比較用詳細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extract(this.productCloseSelectTable))
        );
        this.numLoads = this.numLoads + 1;
      }
    },

    //確定ボタン
    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
      this.showFlag = true;

      //製品クローズ選択の更新
      updateProductCloseSelectData({
        aobQuoteNo: this.aobQuoteNo,
        acceptOrderDetailInfoList: this.productCloseSelectTable,
        user: getUserInfo().UserId,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.numLoads = 1;
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
          this.Init();
        });
    },

    //セルの編集
    editCellData(row, column, cell, event) {
      //「備考」のみ編集可
      if (
        this.closeDataList.includes(row.aodProdNo) &&
        column.property === "aodRemarks"
      ) {
        return true;
      }
      return false;
    },

    //選択項目の変更
    changeSelect(val) {
      this.closeDataList = val.map((item) => item.aodProdNo);

      this.$nextTick(() => {
        this.productCloseSelectTable.map((item) => {
          if (!this.closeDataList.includes(item.aodProdNo)) {
            item.aodRemarks = "";
            item.aodCloseState = "0";
          } else {
            item.aodCloseState = "1";
          }
          return item;
        });
      });
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      //if (row.aodCloseState === "1" && column.property === "aodRemarks") {

      //「備考」のみ編集可
      if (
        this.closeDataList.includes(row.aodProdNo) &&
        column.property === "aodRemarks"
      ) {
        //編集可能の背景色
        return "bg-cell-editable";
      }
      return;
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      //入力ボックスが1つしかない場合
      if (this.closeDataList.length == 1) {
        return;
      }

      index = index + 1;

      if (index > this.productCloseSelectTable.length - 1) {
        for (var i = 0; i < this.productCloseSelectTable.length; i++) {
          if (
            this.$refs[`input${i}-${columnProp}`] !== undefined &&
            this.$refs[`input${i}-${columnProp}`].length !== 0
          ) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
      } else {
        var i = index;

        for (i; i < this.productCloseSelectTable.length; i++) {
          if (
            this.$refs[`input${i}-${columnProp}`] !== undefined &&
            this.$refs[`input${i}-${columnProp}`].length !== 0
          ) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }

        //下に入力ボックスがない場合は、最初から
        if (i == this.productCloseSelectTable.length) {
          this.focusNextInput(-1, columnProp);
        }
      }
    },

    //テーブルで変更される可能性のある列の取得
    extract(data) {
      return data.map((item, index) => {
        return {
          index: index,
          aodCloseState: item.aodCloseState,
          aodRemarks: item.aodRemarks,
        };
      });
    },

    //ダイアログを閉じる
    onCancel() {
      if (
        !cmpDetailData(
          this.cmpDetailResult,
          JSON.parse(JSON.stringify(this.extract(this.productCloseSelectTable)))
        )
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.cell_input .el-input__inner {
  height: 25px !important;
  padding: 0 5px !important;
}
</style>

